import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Form } from 'react-bootstrap'
import { emptyGuid } from '../../../../utils/emptyGuid'
import OverlayContainer from '../../../Page/logix2020/OverlayContainer'
import OverlayRight from '../../../Page/logix2020/OverlayRight'
import AssetGroupsTree from '../../../AssetGroups/AssetGroupsTree'
import StructureIcon from '../../../Icons/StructureIcon'
import styled from 'styled-components'
import { VisualInput } from '../../../Forms/VisualInput'
import { StyledValidationMessage } from '../formHelper'
import { useTranslation } from 'react-i18next'
import useStores from '../../../../stores/useStore'
import { observer } from 'mobx-react'

const StyledButton = styled.div`
  cursor: pointer;
  border: 0;
  background: none;
  padding: 0;
  margin: 0 0 0 10px;
`

const AssetGroupSelect = observer(
  ({
    id,
    label,
    onChange,
    value,
    isInvalid = false,
    withSearch = false,
    noMargin = false,
    errorMessage,
    overLayZIndex,
    showTopLevel,
    disabled = false,
  }) => {
    const [groupName, setGroupName] = useState('')
    const [groups, setGroups] = useState(null)
    const { t } = useTranslation()
    const mountedRef = useRef(true)
    const { assetGroupStore, overlayRightStore, profileStore } = useStores()
    const showGroupTree = overlayRightStore.openOverlay === id

    //Cleanup Function
    useEffect(() => {
      return () => {
        mountedRef.current = false
      }
    }, [])

    useEffect(() => {
      assetGroupStore.getGroups(emptyGuid).then((result) => {
        if (!mountedRef.current) {
          return null
        }
        setGroups(result)
      })
    }, [assetGroupStore])

    const loadGroupName = useCallback(
      async (value) => {
        var loadedGroupName = ''
        try {
          const loadedGroup = await assetGroupStore.getGroup(value)
          loadedGroupName = loadedGroup.displayName
        } finally {
          setGroupName(loadedGroupName)
        }
      },
      [assetGroupStore]
    )

    useEffect(() => {
      if (value && groups !== null && value !== emptyGuid) {
        const foundGroup = groups.find((item) => item.id === value)
        if (foundGroup) {
          setGroupName(foundGroup.displayName)
        } else {
          loadGroupName(value)
        }
      } else if (showTopLevel && value === emptyGuid) {
        setGroupName(profileStore.profile.mandator.displayName)
      } else {
        setGroupName('')
      }
    }, [
      value,
      groups,
      loadGroupName,
      profileStore.profile.mandator.displayName,
      showTopLevel,
    ])

    const handleClickGroup = (group) => {
      assetGroupStore.clearError()
      setGroupName(group.displayName)
      onChange(group.id)
      overlayRightStore.closeAll()
    }

    return (
      <>
        <Form.Group className={noMargin ? 'mb-0' : 'mb-3'}>
          {label && <Form.Label>{label}</Form.Label>}
          <div className='d-flex align-items-start'>
            <VisualInput
              style={{ overflow: 'auto' }}
              className={isInvalid ? 'is-invalid' : ''}
              onClick={() =>
                !disabled ? overlayRightStore.openOrClose(id) : null
              }
            >
              {groupName}
            </VisualInput>
            <StyledButton
              onClick={() =>
                !disabled ? overlayRightStore.openOrClose(id) : null
              }
            >
              <StructureIcon />
            </StyledButton>
          </div>
          {errorMessage && (
            <StyledValidationMessage>{errorMessage}</StyledValidationMessage>
          )}
        </Form.Group>
        <OverlayContainer>
          <OverlayRight
            headerTitle={t('assetGroups:assetGroups')}
            overLayZIndex={overLayZIndex}
            visible={showGroupTree}
            onClose={() => {
              overlayRightStore.closeAll()
            }}
          >
            <div className='content'>
              {showGroupTree && (
                <AssetGroupsTree
                  showTopLevel={showTopLevel}
                  key={`asset-groups-tree`}
                  onClick={handleClickGroup}
                  isClickable={() => true}
                  withSearch={withSearch}
                />
              )}
            </div>
          </OverlayRight>
        </OverlayContainer>
      </>
    )
  }
)

export default AssetGroupSelect
